// @flow
import { all, fork, takeEvery } from "redux-saga/effects";

import {
	CHANGE_TOKEN
} from "./actionTypes";


/**
 * Changes the layout type
 * @param {*} param0
 */
function changeToken({ payload: token }) {
	try {
		localStorage.setItem('activeToken', token);
		let url = window.location.href;
		if(token === 'fa2')
			url = url.replace('erc20', token).replace('polygon', token).replace('avax', token)
		else if(token === 'erc20')
			url = url.replace('fa2', token).replace('polygon', token).replace('avax', token)
		else if(token === 'polygon')
			url = url.replace('fa2', token).replace('erc20', token).replace('avax', token)
		else if(token === 'avax')
			url = url.replace('fa2', token).replace('erc20', token).replace('polygon', token)
		window.location.href = url;

	} catch (error) { }
}

export function* watchToken() {
    yield takeEvery(CHANGE_TOKEN, changeToken)
}

function* TokenSaga() {
	yield all([
		fork(watchToken),
	]);
}

export default TokenSaga;